export default __webpack_public_path__ + "static/media/logofooter.01d75db8.png";